export default __webpack_public_path__ + "static/media/time_circle.b5a4e676.svg";